import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class militaryContactView_template extends vnTemplate {
    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="click: onClickBack" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title icon i-summary" data-bind="text: title">Military Contact</h3>
                    <div class="w-btn">
                        <button type="button" data-bind="visible: path, click: onClickViewOnSite" class="btn icon border only-icon i-link"></button>
                        <button data-bind="click: onClickEdit" class="btn icon i-edit" type="button">Edit Contact</button>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Base</label>
                                <div data-bind="text: baseTitle"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Phone</label>
                                <div data-bind="text: phone"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Path</label>
                                <div data-bind="text: path"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Status</label>
                                <div data-bind="text: status() ? 'Active' : 'Inactive'"></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Website</label>
                            <div data-bind="text: websiteUri"></div>
                        </div>
                        <strong class="form-sub-title">Address</strong>
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Street 1</label>
                                <div data-bind="text: addressStreet1"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Street 2</label>
                                <div data-bind="text: addressStreet2"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Zip Code</label>
                                <div data-bind="text: addressZipCode"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Building Number</label>
                                <div data-bind="text: addressBuildingNumber"></div>
                            </div>
                        </div>
                        <div class="form-group-row">
                            <div class="form-group">
                                <label class="form-label">Cross Street</label>
                                <div data-bind="text: addressCrossStreet"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">City</label>
                                <div data-bind="text: addressCity"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">State</label>
                                <div data-bind="text: addressState"></div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Country</label>
                                <div data-bind="text: addressCountry"></div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Hours</label>
                            <div data-bind="html: hours"></div>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Body</label>
                            <div data-bind="html: body"></div>
                        </div>

                        <strong class="form-sub-title">Help Services Referencing This Contact</strong>
                        <div class="w-list-results">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th>Help Service</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: referencedHelpServices, visible: referencedHelpServices().length > 0">
                                    <tr>
                                        <td data-bind="text: title"></td>
                                        <td>
                                            <button class="btn icon border only-icon i-view" type="button" data-bind="click: $parent.onClickReferencedHelpService"></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody data-bind="visible: referencedHelpServices().length == 0">
                                    <tr>
                                        <td colspan="2">No help services reference this contact.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <strong class="form-sub-title">Bases Referencing This Contact</strong>
                        <div class="w-list-results">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th>Base</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: referencedBases, visible: referencedBases().length > 0">
                                    <tr>
                                        <td data-bind="text: title"></td>
                                        <td>
                                            <button class="btn icon border only-icon i-view" type="button" data-bind="click: $parent.onClickReferencedBase"></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody data-bind="visible: referencedBases().length == 0">
                                    <tr>
                                        <td colspan="2">No bases reference this contact.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "militaryContactView-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            id: ko.observable(null),
            title: ko.observable(""),
            baseTitle: ko.observable(""),
            phone: ko.observable(""),
            websiteUri: ko.observable(""),
            path: ko.observable(""),
            hours: ko.observable(""),
            body: ko.observable(""),
            addressStreet1: ko.observable(""),
            addressStreet2: ko.observable(""),
            addressZipCode: ko.observable(""),
            addressBuildingNumber: ko.observable(""),
            addressCrossStreet: ko.observable(""),
            addressCity: ko.observable(""),
            addressState: ko.observable(""),
            addressCountry: ko.observable(""),
            status: ko.observable(true),
            referencedHelpServices: ko.observableArray([]),
            referencedBases: ko.observableArray([]),
            onClickBack: function () {
                self.caller.cancel();
            },
            onClickEdit: function () {
                self.caller.editContact();
            },
            onClickViewOnSite: function (data, event) {
                return self.onClickViewOnSite(data, event);
            },
            onClickReferencedHelpService: function (helpService) {
                self.caller.viewReferencedHelpService(helpService);
            },
            onClickReferencedBase: function (base) {
                self.caller.viewReferencedBase(base);
            }
        };
    }

    public setContact(contact, usStates = {}): void {
        const vm = this.getTemplateViewModel();
        const website = contact.website || {};
        const address = contact.address || {};
        vm.id(contact.id);
        vm.title(contact.title || "");
        vm.baseTitle(contact.base ? contact.base.title : "");
        vm.phone(contact.phone || "");
        vm.websiteUri(website.uri || "");
        vm.path(contact.path || "");
        vm.hours(contact.hours || "");
        vm.body(contact.body || "");
        vm.addressStreet1(address.street1 || "");
        vm.addressStreet2(address.street2 || "");
        vm.addressZipCode(address.zipCode || "");
        vm.addressBuildingNumber(address.buildingNumber || "");
        vm.addressCrossStreet(address.crossStreet || "");
        vm.addressCity(address.city || "");
        vm.addressState(this.getDisplayState(address, usStates));
        vm.addressCountry(address.country || "");
        vm.status(contact.status !== false);
    }

    public setReferencedHelpServices(helpServices): void {
        this.getTemplateViewModel().referencedHelpServices(helpServices || []);
    }

    public setReferencedBases(bases): void {
        this.getTemplateViewModel().referencedBases(bases || []);
    }

    protected getDisplayState(address, usStates): string {
        if (!address || address.country != "United States") {
            return address && address.state ? address.state : "";
        }

        const stateCode = String(address.state || "").toUpperCase();
        return stateCode && usStates[stateCode] ? usStates[stateCode] : (address.state || "");
    }

    protected onClickViewOnSite(data, event): boolean {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const vm = this.getTemplateViewModel();

        this.caller.viewContactOnSite(vm.path());
        return false;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/militaryContactView_template.ts